var map = {
	"./subnav.de-CH.json": 1511,
	"./subnav.de-DE.json": 1512,
	"./subnav.en-CA.json": 1513,
	"./subnav.en-GB.json": 1514,
	"./subnav.en-IN.json": 1515,
	"./subnav.en-ME.json": 1516,
	"./subnav.en-US.json": 1517,
	"./subnav.es-EM.json": 1518,
	"./subnav.es-ES.json": 1519,
	"./subnav.fr-BE.json": 1520,
	"./subnav.fr-CA.json": 1521,
	"./subnav.fr-CH.json": 1522,
	"./subnav.nl-BE.json": 1523,
	"./subnav.nl-NL.json": 1524,
	"./subnav.pl-PL.json": 1525,
	"./subnav.pt-BR.json": 1526
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1510;